import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g>
      <path d="M11.2755581,29 L11.8703107,31 L-2.90434343e-13,31 L7.62099294,16.7106382 L8.43241121,19.439229 L3.33333333,29 L11.2755581,29 Z" fillRule="nonzero">
      
      </path>
      <path d="M28.92,31 L23.9326688,14.4024338 C21.9100777,7.6604633 15.7205626,3.03533049 8.68813463,3.0002015 L10.48818,9.00025262 C10.4590367,9.00008427 10.4298778,9 10.4007038,9 L8.40004,9 L6,1 L8.60744828,1 C16.5563963,1 23.564208,6.21402676 25.8483214,13.8277381 L31,31 L28.92,31 Z"
            fillRule="nonzero">
        
      </path>
      <path className="euiIcon__fillSecondary"
            d="M12.0372994,14.0201336 L16.4919569,29 L23.3191059,29 L20.9862864,21.1510343 C19.7862893,17.1135441 16.1963314,14.2837713 12.0372994,14.0201336 Z M9.35,12 L11.4007038,12 C16.7113604,12 21.390415,15.4906673 22.9034029,20.5812411 L26,31 L15.00015,31 L9.35,12 Z"
            fillRule="nonzero">
        
      </path>
    </g>
  </svg>
)
